import type { RootState } from 'state';
import type { CarriersState } from '../slice';

function getCarriers(state: RootState): CarriersState['value'] {
  const { value } = state.packageCache.flightRoutes.carriers;
  return value;
}

export default getCarriers;
